import React from 'react';

import classNames from 'classnames';
import styles from './NavigatorIconsVersion.module.scss';
import ArrowForward from './arrow_forward.svg';
import ArrowBack from './arrow_back.svg';

interface INavigatorProps {
  className?: string;
  nextClassName?: string;
  prevClassName?: string;
}

const NavigatorIconsVersion = ({
  className,
  nextClassName = 'next',
  prevClassName = 'previous'
}: INavigatorProps) => {
  const prev = classNames(prevClassName, styles.Prev);
  const next = classNames(nextClassName, styles.Next);

  return (
    <div className={classNames(className, styles.Navigator)}>
      <button className={prev} aria-label="Previous" type="button">
        <ArrowBack />
      </button>
      <button className={next} aria-label="Next" type="button">
        <ArrowForward />
      </button>
    </div>
  );
};

export default NavigatorIconsVersion;
